import * as React from 'react';
import { ArchetypeSpecificStepRunSummaryPanelProps } from '.';

export const ReleaseCandidateStepRunSummaryPanel: React.FC<ArchetypeSpecificStepRunSummaryPanelProps> = ({
    stepRun,
}) => {
    return <div>Release Candidate Step Run Summary Panel - {stepRun.displayName || stepRun.stepId}</div>;
};
